import { Script } from 'nordic/script';
import React from 'react';

export default function bootstrapNordicPages(Component) {
  const WithBootstrapComponent = props => (
    <>
      <Component {...props} />
      <Script>
        {` 
        window.newrelic?.setErrorHandler(err => {
          const ignoreStatusMessages = ['Script error.'];
          let response = false;

          for (let i = 0; i < ignoreStatusMessages.length; i++) {
            const element = ignoreStatusMessages[i];
            if (err.message === element) {
              response = true;
            }
          }

          return response;
        });
        `}
      </Script>
    </>
  );

  return WithBootstrapComponent;
}
